import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_FACEBOOK_CTA_INTL = defineFcm('psf_promote_or_share_facebook_cta_intl')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		deprecated:
			'Experiment FCM — no longer referenced after productizing the channel-aware CTA (CHANGE-100764). Safe to delete after 2026-10-28.',
		context: 'psf promote-or-share share slide-up',
		description:
			'DEPRECATED legacy experiment binding (Facebook, Top-8 relaunch, CHANGE-99290): kill-switch + experiment binding for the "Share on Facebook" CTA on the promote_or_share share slide-up. The experiment concluded with variant_2 (cta_only) winning, now productized via psf_promote_or_share_channel_aware_cta (CHANGE-100764). Kept only until cached front-end bundles rotate, then deleted.',
		template: {
			enabled: false,
			experimentName: 'psf_promote_or_share_facebook_cta_top_8',
		},
	});
